import Swiper, { Navigation, Pagination } from 'swiper';
import $ from 'jquery';

let windowWidth = $(window).width();

function initBlockWithTabsAndSlider() {
  const sliders = $('.itinerary-carousel');
  // const breakpoints = [];
  const keyCodesAvailable = [undefined, 1, 13, 32];

  document.querySelectorAll('.itinerary-carousel').forEach((slider) => {
    const sliderItem = new Swiper(slider.querySelector('.itinerary-carousel__swiper-container'), {
      init: false,
      modules: [Navigation, Pagination],
      speed: 700,
      slidesPerView: 1,
      spaceBetween: 15,
      autoHeight: true,
      navigation: {
        nextEl: slider.querySelector('.itinerary-carousel__nav--next'),
        prevEl: slider.querySelector('.itinerary-carousel__nav--prev'),
      },
      pagination: {
        el: slider.querySelector('.itinerary-carousel__swiper-pagination'),
      },
      on: {
        init: () => {
          $(sliderItem.$el).find($('a')).attr('tabindex', -1);
          $(sliderItem.$el).find($('.swiper-slide-active')).find($('a')).attr('tabindex', 0);
        },
        slideChangeTransitionEnd: () => {
          $(sliderItem.$el).find($('a')).attr('tabindex', -1);
          $(sliderItem.$el).find($('.swiper-slide-active')).find($('a')).attr('tabindex', 0);
        },
      },
    });

    sliderItem.init();
    sliders.push(sliderItem);

    const sliderTabsInside = slider.querySelectorAll('.itinerary-carousel__name');
    const sliderTabsWrapper = slider.querySelector('.itinerary-carousel__tabs');

    for (let i = 0; i < sliderTabsInside.length; i++) {
      const newTab = document.createElement('li');
      newTab.classList.add('itinerary-carousel__tab');
      newTab.setAttribute('data-index', i);
      newTab.setAttribute('tabindex', 0);
      newTab.textContent = sliderTabsInside[i].textContent;
      sliderTabsWrapper.append(newTab);

      if (newTab.textContent <= 0) {
        newTab.classList.add('itinerary-carousel__tab--empty');
      }

      sliderTabsInside[i].remove();
    }

    const sliderTabs = slider.querySelectorAll('.itinerary-carousel__tab');

    for (let i = 0; i < sliderTabs.length; i++) {
      sliderTabs[0].classList.add('active');

      $(sliderTabs[i]).on('click keyup', (event) => {
        if (keyCodesAvailable.indexOf(event.keyCode) !== -1) {
          sliderTabs.forEach((elem) => elem.classList.remove('active'));
          sliderTabs[i].classList.add('active');
          sliderItem.slideTo(sliderTabs[i].dataset.index);
        }
      });
    }

    sliderItem.on('slideChange', () => {
      const currentIndex = sliderItem.realIndex;

      sliderTabs.forEach((elem) => {
        if (elem.dataset.index == currentIndex) {
          elem.classList.add('active');
        } else {
          elem.classList.remove('active');
        }
      });
    });

    const prevSlideBtn = slider.querySelector('.itinerary-carousel__nav--prev');
    const nextSlideBtn = slider.querySelector('.itinerary-carousel__nav--next');
    const mobileControlsWrapper = slider.querySelector('.itinerary-carousel__mobile-btns');

    prevSlideBtn.setAttribute('tabindex', 0);
    nextSlideBtn.setAttribute('tabindex', 0);

    if (window.innerWidth < 992) {
      mobileControlsWrapper.append(prevSlideBtn);
      mobileControlsWrapper.append(nextSlideBtn);

      const clones = slider.querySelectorAll('.itinerary-carousel__item');

      slider.querySelectorAll('.swiper-slide').forEach((elem) => elem.remove());

      for (let i = 0; i < clones.length; i++) {
        const newSlide = document.createElement('p');
        newSlide.classList.add('swiper-slide');
        newSlide.append(clones[i]);
        slider.querySelector('.swiper-wrapper').append(newSlide);
      }
    }
  });
}

$(window).on('load', () => {
  initBlockWithTabsAndSlider();
});

$(window).on('resize', () => {
  if ($(window).width() !== windowWidth) {
    windowWidth = $(window).width();
    initBlockWithTabsAndSlider();
  }
});
